import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20amber%20coral%20and%20cream%20tones%2C%20soft%20bokeh%20light%20particles%2C%20modern%20minimalist%20aesthetic%2C%20artistic%20composition%20with%20fluid%20textures%2C%20gentle%20motion%20blur%2C%20warm%20atmospheric%20glow&width=1800&height=900&seq=hero-bg-jiujiure&orientation=landscape"
        alt="久久热背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white max-w-3xl leading-tight">
          发现热门，追踪趋势
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-white/85 max-w-2xl leading-relaxed">
          海量精彩内容持续更新，覆盖娱乐、资讯、生活等多元领域，每天都有新鲜好内容
        </p>
        <div className="mt-8 md:mt-10 flex items-center gap-4">
          <Link
            to="/category/zixun"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            探索热门内容
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/30"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 md:mt-14 flex items-center gap-8 text-white/70">
          <div className="flex flex-col items-center">
            <span className="text-2xl md:text-3xl font-bold text-white">1200+</span>
            <span className="text-xs mt-1">精选文章</span>
          </div>
          <div className="w-px h-8 bg-white/20" />
          <div className="flex flex-col items-center">
            <span className="text-2xl md:text-3xl font-bold text-white">6</span>
            <span className="text-xs mt-1">内容分类</span>
          </div>
          <div className="w-px h-8 bg-white/20" />
          <div className="flex flex-col items-center">
            <span className="text-2xl md:text-3xl font-bold text-white">50万+</span>
            <span className="text-xs mt-1">月活用户</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl" />
      </div>
    </section>
  );
}